import { render, staticRenderFns } from "./view3.vue?vue&type=template&id=50703d83&scoped=true"
import script from "./view3.vue?vue&type=script&lang=js"
export * from "./view3.vue?vue&type=script&lang=js"
import style0 from "./view3.vue?vue&type=style&index=0&id=50703d83&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50703d83",
  null
  
)

export default component.exports